import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Card, CardHeader, makeStyles, CardContent } from '@material-ui/core'
import OpenQuestion from './OpenQuestion'
import SingleChoiceOptions from './SingleChoiceOptions'
import MultipleChoiceOptions from './MultipleChoiceOptions'
import { ChecklistQuestionType } from '../../../../store/helpers/AppConstants'

const Questions = (props) => {
	const classes = ServiceChecklistsStyles()
	const { section, onChecklistResponse, checklistResponse, canBeAddedResponse, isSaving } = props

	return (
		<CardContent style={{ padding: 0 }}>
			{section.Questions.map((question, questionIndex) => {
				return (
					<Card
						key={questionIndex}
						style={{
							marginBottom: '2px',
							paddingLeft: '5px',
							paddingRight: '5px',
							paddingBottom: '8px',
							border: '1px solid #ddd'
						}}
					>
						<CardHeader
							title={
								<Typography variant='subtitle1' className={classes.questionTitle}>
									{`${section.OrderIndex}.${questionIndex + 1} ${question.Title}`}
								</Typography>
							}
						/>
						{question.Type === ChecklistQuestionType.OPEN_ENDED && (
							<OpenQuestion
								onChecklistResponse={onChecklistResponse}
								//objects
								checklistResponse={checklistResponse}
								// survey={survey}
								question={question}
								// supplierSurveyResponse={supplierSurveyResponse}
								canBeAddedResponse={canBeAddedResponse}
								// bool props
								isSaving={isSaving}
							/>
						)}
						{question.Type === ChecklistQuestionType.SINGLE_CHOICE && (
							<SingleChoiceOptions
								//bool
								canBeAddedResponse={canBeAddedResponse}
								isSaving={isSaving}
								//object
								question={question}
								checklistResponse={checklistResponse}
								onChecklistResponse={onChecklistResponse}
							/>
						)}
						{question.Type === ChecklistQuestionType.MULTIPLE_CHOICE && (
							<MultipleChoiceOptions
								//bool
								canBeAddedResponse={canBeAddedResponse}
								isSaving={isSaving}
								// canBeAddedResponse={canBeAddedResponse}
								//object
								question={question}
								checklistResponse={checklistResponse}
								// survey={survey}
								// supplierSurveyResponse={supplierSurveyResponse}
								//fucntions
								// onOpenCloseDeleteOptionConfigPanel={onOpenCloseDeleteOptionConfigPanel}
								// onOpenCloseEditOptionConfigPanel={onOpenCloseEditOptionConfigPanel}
								// onAddSurveyAnswerFromBackEnd={onAddSurveyAnswerFromBackEnd}
								onChecklistResponse={onChecklistResponse}
							/>
						)}
					</Card>
				)
			})}
		</CardContent>
	)
}

export const ServiceChecklistsStyles = makeStyles((theme) => ({
	container: {
		padding: '5px',
		backgroundColor: '#f9f9f9'
	},
	card: {
		marginBottom: '5px',
		borderRadius: '8px',
		boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
		padding: 0,
		'&:last-child': {
			paddingBottom: 0
		}
	},
	avatar: {
		backgroundColor: theme.palette.primary.main
	},
	sectionCard: {
		marginBottom: '5px',
		borderRadius: '8px',
		boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)'
	},
	questionBlock: {
		marginTop: '16px'
	},
	questionTitle: {
		fontWeight: 'bold'
		// marginBottom: '8px',
	},
	addOptionContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginBottom: '16px'
	},
	addOptionButton: {
		borderColor: theme.palette.primary.main,
		color: theme.palette.primary.main,
		textTransform: 'none',
		fontSize: '0.85rem',
		fontWeight: 'bold',
		'&:hover': {
			backgroundColor: theme.palette.primary.light,
			borderColor: theme.palette.primary.dark
		}
	},
	emptyStateContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '32px',
		backgroundColor: '#fff',
		borderRadius: '8px',
		boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
		marginTop: '16px'
	},
	addButton: {
		backgroundColor: '#1976d2',
		color: '#fff',
		border: '1px solid #1976d2',
		borderRadius: '4px'
	},
	editButton: {
		backgroundColor: '#f0f0f0',
		color: '#000',
		border: '1px solid #ccc',
		borderRadius: '4px'
	},
	deleteButton: {
		backgroundColor: '#d32f2f',
		color: '#fff',
		border: '1px solid #d32f2f',
		borderRadius: '4px'
	}
}))

Questions.propTypes = {
	serie: PropTypes.shape({
		Serie: PropTypes.string,
		Model: PropTypes.string
	}),
	onSave: PropTypes.func.isRequired
}

export default Questions
